

export const sizeTemplate = {
  male: ["4", "4.5", "5", "5.5", "6", "6.5", "7", "7.5", "8", "8.5", "9", "9.5", "10", "10.5", "11", "11.5", "12", "12.5", "13", "14"],
  female: ["4", "4.5", "5", "5.5", "6", "6.5", "7", "7.5", "8", "8.5", "9", "9.5", "10", "10.5", "11", "11.5", "12", "12.5", "13", "14"],
  primarySchool: ["10.5C", "11C", "11.5C", "12C", "13C", "13.5C", "1Y", "1.5Y", "2Y", "2.5Y", "3Y"],
  gradeSchool: ["3.5Y", "4Y", "4.5Y", "5Y", "5.5Y", "6Y", "6.5Y", "7Y", "7.5Y", "8Y"],
  infantToodler: ["2C", "2.5C", "3C", "3.5C", "4C", "4.5C", "5C", "5.5C", "6C", "6.5C", "7C", "7.5C", "8C", "8.5C", "9C", "9.5C", "10C"]
}